import { SessionProvider } from '@sdk/session/SessionContext';

import { QueryClientProvider } from '@web/components/QueryClientProvider/QueryClientProvider';
import { AnnouncementsList } from '@web/announcements/AnnouncementsList/AnnouncementsList';

export const Announcements = () => (
  <QueryClientProvider>
    <SessionProvider>
      <AnnouncementsList />
    </SessionProvider>
  </QueryClientProvider>
);
